export const EDevice = {
  Desktop: "Desktop",
  Mobile: "Mobile",
} as const;

export type EDevice = typeof EDevice[keyof typeof EDevice];
